import { WifiOff } from '@mui/icons-material';
import React, { useState, useEffect } from 'react';

import { StatusBar } from './ConnectionStatus.styles';

export const ConnectionStatus: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <StatusBar isOnline={isOnline}>
      <WifiOff fontSize="small" />
      You are offline
    </StatusBar>
  );
};
